import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'app-rollin-view',
  templateUrl: './rollin-view.component.html',
  styleUrls: ['./rollin-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class RollInViewComponent extends ComponentBase implements OnInit, OnDestroy {

  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.screenWidthChange(this.store, (width: number) => {});
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

}
